import stx_box from 'src/assets/stx_box.png'
import ont from 'src/assets/ont.png'

export const products = [
  {
    title: 'STB box for multimedia',
    specs: [
      'Android based',
      'Customised remote',
      'Multicast',
      'Uunicast',
      'System integrated WuFlux APK',
    ],
    img: stx_box,
  },
  {
    title: 'ONT',
    specs: [
      '4GE+WiFi  GPON/EPON ONT',
      'WiFi Mesh terminal devices FTTH',
      'Triple play service demand of fixed network operators',
    ],
    img: ont,
  },
]
